import { Button } from '@accure/ui';

import { Card } from '@/components/ui/card';
import { useAddWorkstreamModal } from '@/project-management/modals/add-workstream';

export function WorkstreamsEmpty() {
  const showAddWorkstreamModal = useAddWorkstreamModal();

  return (
    <Card className="space-y-4 p-6">
      <div className="w-full flex-col items-center justify-center p-6 text-center">
        <h3 className="mb-2 text-lg font-medium text-gray-900">
          No workstreams yet
        </h3>
        <p className="mb-4 text-gray-600">
          Create your first workstream to organize tasks, track progress, and
          manage your project more effectively.
        </p>
        <Button
          onClick={() => showAddWorkstreamModal('template')}
          size="sm"
          className=""
        >
          + Create Workstream
        </Button>
      </div>
    </Card>
  );
}
